import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["vertical"];
import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../../themes';
import StyledContainer from '../../Styled/StyledContainer';
var Horizontal = /*#__PURE__*/styled(StyledContainer).withConfig({
  displayName: "Divider__Horizontal",
  componentId: "sc-1s1884-0"
})(["margin-top:0;margin-bottom:34px;border-top:1px solid ", ";border-left:none;border-right:none;"], COLORS.NEUTRAL_200);
var Vertical = /*#__PURE__*/styled(StyledContainer).withConfig({
  displayName: "Divider__Vertical",
  componentId: "sc-1s1884-1"
})(["margin:0 40px 24px 40px;border:none;border-left:1px solid ", ";"], COLORS.NEUTRAL_200);

/**
 * @deprecated
 */
var Divider = function Divider(_ref) {
  var vertical = _ref.vertical,
      rest = _objectWithoutProperties(_ref, _excluded);

  return vertical ? /*#__PURE__*/React.createElement(Vertical, rest) : /*#__PURE__*/React.createElement(Horizontal, _extends({
    as: "hr"
  }, rest));
};

export default Divider;